import React, { useEffect, useMemo } from 'react';
import { FailedDeliveryCard } from './components';
import { AsyncBoundary } from '../../../components/AsyncBoundary';
import { FailedDelivery } from './driverFailedDeliveriesTypes';
import { useDeliveriesStore } from '../../../store/deliveriesStore';
import { DeliveryStop } from '../../../services/deliveriesApi';
import styles from './DriverFailedDeliveries.module.css';

function adapt(s: DeliveryStop): FailedDelivery {
  return {
    id: String(s.id),
    storeName: s.customer_name || `Order ${s.order_id}`,
    address: s.customer_address || '—',
    reason: s.failure_reason || 'Unknown',
    description: s.failure_notes || '—',
    status: 'Failed',
  };
}

const DriverFailedDeliveries: React.FC = () => {
  const stops = useDeliveriesStore((s) => s.stops);
  const loading = useDeliveriesStore((s) => s.loading);
  const error = useDeliveriesStore((s) => s.error);
  const fetchMyStops = useDeliveriesStore((s) => s.fetchMyStops);

  useEffect(() => {
    fetchMyStops({ status: 'failed' });
  }, [fetchMyStops]);

  const failed = useMemo<FailedDelivery[]>(
    () => stops.filter((s) => s.status === 'failed').map(adapt),
    [stops]
  );

  return (
    <div className={styles.container}>
      <AsyncBoundary
        loading={loading && stops.length === 0}
        error={error}
        empty={!loading && failed.length === 0}
        emptyMessage="No failed deliveries on record"
        onRetry={() => fetchMyStops({ status: 'failed' })}
      >
        {failed.map((delivery) => (
          <FailedDeliveryCard key={delivery.id} delivery={delivery} />
        ))}
      </AsyncBoundary>
    </div>
  );
};

export const DriverFailedDeliveriesPage: React.FC = () => <DriverFailedDeliveries />;

export { DriverFailedDeliveries };
export default DriverFailedDeliveries;
